import { Box, Center, Container, Flex, Square, Text } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react'
import { Route, Routes } from 'react-router-dom';
import { Category, Create, Feed, NavBar, Search, UserProfile, VideoPin, VideoPinDetail } from '../Components'
import { categories } from '../data'



const Home = ({ user }) => {



    // console.log(user)
    return <>
        <NavBar user={user} />
        <Flex width={'100vw'}>
            <Flex
                direction={'column'} justifyContent='start'
                alignItems={'center'}
                width={'20vw'}
            >
                {categories && categories.map(data => <Category key={data.id} data={data} />)}
            </Flex>
            <Flex
                width={'75vw'}
                mx={5}
                justifyContent='center'
                alignItems={'center'}
            >
                <Routes>
                    <Route path="/" element={<Feed />} />
                    <Route path="/category/:categoryId" element={<Feed />} />
                    <Route path="/create" element={<Create />} />
                    <Route path="/videoDetail/:videoId" element={<VideoPinDetail />} />
                    <Route path="/search" element={<Search />} />
                    <Route path="/userDetail/:userId" element={<UserProfile />} />
                </Routes>
            </Flex>

        </Flex>


        {/* <Flex color=''>
            <Box
                w={[100, 200, 300]}
                direction={'column'} justifyContent='start'
                alignItems={'center'}
            >
                <Container>
                    <Text>
                        {categories && categories.map(data => <Category key={data.id} data={data} />)}
                    </Text>
                </Container>
            </Box>
            <Center flex='1' bg=''>
                <Flex color=''>
                    <Flex
                        width={'100%'}
                        mx={5}
                        justifyContent='center'
                        alignItems={'center'}
                    >
                        <Routes>
                            <Route path="/" element={<Feed />} />
                            <Route path="/category/:categoryId" element={<Feed />} />
                            <Route path="/create" element={<Create />} />
                            <Route path="/videoDetail/:videoId" element={<VideoPinDetail />} />
                            <Route path="/search" element={<Search />} />
                            <Route path="/userDetail/:userId" element={<UserProfile />} />
                        </Routes>
                    </Flex>




                </Flex>
            </Center>
        </Flex> */}
    </>

};

export default Home
